import React from "react";
import { Info } from "lucide-react";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";

/*
 * Shown on Save when "Hiring management access" is ON but not a single Hiring
 * permission has been picked.
 *
 * In that state the role gains nothing — it would still see only the default
 * employee Hiring screen (browse open jobs, refer a candidate), never the
 * admin console (Hiring dashboard, create / close jobs, import candidates).
 * So the save is held back: the admin either goes back and chooses at least
 * one permission, or presses OK to switch the section off and save the rest.
 */
const HiringManagementEmptyModal = ({ roleName, onCancel, onConfirm }) => (
  <div className="rpe-modal-overlay" onClick={onCancel}>
    <div className="rpe-modal" onClick={(e) => e.stopPropagation()}>
      <div className="rpe-modal-icon-info">
        <Info size={20} />
      </div>
      <h2 className="rpe-modal-title">
        No Hiring permissions selected
      </h2>
      <p className="rpe-modal-subtitle">
        “Hiring management access” is on, but nothing below it is turned on, so
        there is nothing to save for Hiring. {roleName ? `“${roleName}”` : "This role"} would
        still get only the default Hiring screen — browse open jobs and refer a
        candidate — and none of the admin tools like the Hiring dashboard,
        creating or closing jobs, or importing candidates.
      </p>
      <p className="rpe-modal-subtitle" style={{ marginTop: 10 }}>
        Go back to pick at least one permission, or press OK to turn the section
        off and save your other changes.
      </p>
      <div className="rpe-modal-actions rpe-modal-actions-center">
        <SecondaryButton type="button" onClick={onCancel}>
          Go back
        </SecondaryButton>
        <PrimaryButton type="button" width="120px" onClick={onConfirm}>
          OK
        </PrimaryButton>
      </div>
    </div>
  </div>
);

export default HiringManagementEmptyModal;
